import qs from 'qs';

import { v1ApiClient } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import type { NotificationHistory } from '../model/types';

type GetNotificationHistoryParams = {
  workspace_id?: string;
  ids: string[];
  offset: number;
  limit: number;
};
type GetNotificationHistoryResponse = NotificationHistory[];
type GetNotificationHistoryFunction = (
  params: GetNotificationHistoryParams,
) => Promise<GetNotificationHistoryResponse>;

/**
 * 알림 히스토리 조회
 * @note API endpoint has typo: "hsitory" instead of "history"
 */
export const getNotificationHistory: GetNotificationHistoryFunction = ({
  workspace_id,
  ids,
  offset,
  limit,
}) => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .get(`/workspaces/${wa}/notifications/hsitory`, {
      params: { ids, offset, limit },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((res) => res.data);
};
